import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    activeTab: { type: String, default: "border-primary-strong text-primary-strong" },
    inactiveTab: { type: String, default: "border-transparent text-gray-500" },
    defaultPanel: { type: String, default: "" }
  }

  connect() {
    this.select({ currentTarget: this.defaultTab() })
  }

  // Resolved by panel name rather than position, since tab lists here are conditional.
  defaultTab() {
    const named = this.tabTargets.find(
      tab => tab.getAttribute("aria-controls") === `panel-${this.defaultPanelValue}`
    )

    return named || this.tabTargets[0]
  }

  select(event) {
    const selectedTab = event.currentTarget
    const index = this.tabTargets.indexOf(selectedTab)

    this.tabTargets.forEach((tab, i) => {
      const isActive = i === index
      this.activeTabValue.split(" ").forEach(cls => tab.classList.toggle(cls, isActive))
      this.inactiveTabValue.split(" ").forEach(cls => tab.classList.toggle(cls, !isActive))
      tab.setAttribute("aria-selected", isActive ? "true" : "false")
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
